'use strict'
/**
 * surfaceState.js — Los cuatro estados explícitos (MACRO 1 · Parte C).
 *
 * Mata el verde fabricado: hoy LOADING, EMPTY-honesto, DATA y ERROR
 * colapsan a veces al mismo fallback. Este tipo discriminado fuerza
 * la distinción que el founder hace conceptualmente:
 *
 *   LOADING       → cargando, aún no se sabe nada
 *   DATA          → dato validado contra esquema
 *   EMPTY_HONEST  → el dato NO existe legítimamente (DATO POBRE).
 *                   El ÚNICO estado que puede renderizar "Aún aprendiendo de ti".
 *   ERROR         → el contrato se rompió (BUG). Va a telemetría.
 *                   NUNCA renderiza contenido que parezca dato.
 */

const LOADING = 'LOADING'
const DATA = 'DATA'
const EMPTY_HONEST = 'EMPTY_HONEST'
const ERROR = 'ERROR'

const loading = () => ({ kind: LOADING })
const data = (value) => ({ kind: DATA, value })
const emptyHonest = (reason) => ({ kind: EMPTY_HONEST, reason: reason || 'sin datos todavía' })
const error = (detail) => ({ kind: ERROR, detail: detail || 'contrato roto' })

const isLoading = (s) => s?.kind === LOADING
const isData = (s) => s?.kind === DATA
const isEmptyHonest = (s) => s?.kind === EMPTY_HONEST
const isError = (s) => s?.kind === ERROR

module.exports = {
  LOADING, DATA, EMPTY_HONEST, ERROR,
  loading, data, emptyHonest, error,
  isLoading, isData, isEmptyHonest, isError,
}
